var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-building"}},_vm._l((_vm.groupedAssets),function(ref){
var key = ref[0];
var value = ref[1];
return _c('div',{key:key},[_c('factory-line',{attrs:{"line-assets":value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }